import { useToolHostContext, useToolSituationalContext } from '../../../../contexts/toolItemsHooks';

/**
 * Live session tools run inside LiveToolRunner with preloaded items and
 * submit via ToolWrapper (no navigation on complete).
 */
export function useLiveToolSession() {
  const hostContext = useToolHostContext();
  const situationalContext = useToolSituationalContext();
  const isLiveSession =
    hostContext === 'session' &&
    situationalContext?.completion?.navigateOnComplete === false;
  const isAppMode = hostContext !== 'standalone';
  const shouldAutoStart = isAppMode || isLiveSession;
  const useWorkspaceIds = hostContext === 'session' || hostContext === 'task';
  const completeLabel = situationalContext?.completion?.label ?? 'Submit my response';

  return {
    isLiveSession,
    isAppMode,
    shouldAutoStart,
    useWorkspaceIds,
    hostContext,
    completeLabel,
    importSourceLabel: hostContext === 'session' ? 'session' : 'workspace',
  };
}
